
window.preloadImg = function(imgs){
    for (let i = 0; i < imgs.length; i++){
        let img = $('body').createElementInside('img').addClass('image-preload').addAttr('src', imgs[i]);
    }
}


/*
window.carousel_ = function(imgs, target, duration = 10000){
    imgs.push(imgs[0]);
    imgs.shift();
    //preloadImg(imgs);
    var tabImg = [];
    for (let i = 0; i < imgs.length; i++){
        let _img = new Image;
        _img.src = imgs[i].img;
        tabImg.push(_img);
    }

    var img1 = $(target);
    var cont = img1.parentElement;
    var cl = img1.classList;
    var img2 = img1.createElementAfter('img').addClass('carousel-img-top');
    var index = 0;

    const swapImg = function(){
        if(img2.hasClass('show')){
            img1.src =  imgs[index].img;
            img2.removeClass('show');
        }else{
            img2.src =  imgs[index].img;
            img2.addClass('show');
        }
        cont.removeAttr('data-content').removeClass('legend-on');
        let legend = imgs[index].legend;
        if(imgs[index].credit != '') legend += legend != '' ? ' - ' + imgs[index].credit : imgs[index].credit;
        if(legend != '') cont.addAttr('data-content', legend).addClass('legend-on');
        index ++;
        if(index >= imgs.length) index = 0;
    }

    const trySwapImg = function(){
        if(tabImg[index].complete){
            swapImg();
            setTimeout(trySwapImg, duration);
        }else{
            setTimeout(trySwapImg, 100);
        }
    }
    setTimeout(trySwapImg, duration);
}
*/

window.carousel = function(imgs, target, duration = 10000){
    var tabImg = [];
    target = $(target);
    const parent = target.parentElement;
    var index = 0;
    var current = null;

    for (let i = 0; i < imgs.length; i++){
        let _img = new Image;
        _img.src = imgs[i].img;
        _img.addClass('carousel-img');
        parent.insertBefore(_img, target.nextSibling);
        tabImg.push(_img);
    }

    const legend = function(){
        parent.removeAttr('data-content').removeClass('legend-on');
        let legend = imgs[index].legend;
        if(imgs[index].credit != '') legend += legend != '' ? ' - ' + imgs[index].credit : imgs[index].credit;
        if(legend != '') parent.addAttr('data-content', legend).addClass('legend-on');
    }

    const swapImg = function(){
        if(current) current.removeClass('show');
        index ++;
        if(!tabImg[index]) index = 0;
        current = tabImg[index].addClass('show');
        legend();
    }

    const trySwapImg = function(){
        if(tabImg[index].complete){
            swapImg();
            setTimeout(trySwapImg, duration);
        }else{
            setTimeout(trySwapImg, 100);
        }
    }
    setTimeout(trySwapImg, duration);
}
